import React, { useState, useEffect } from 'react';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';

const Searchbar = () => {
  const [searchresponsive, setSearchresponsive] = useState(false);

  // Reset search state when component unmounts or search is closed externally
  useEffect(() => {
    const searchFullElement = document.querySelector('.search-full');

    // Create observer to watch for class changes on search-full
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const isOpen = searchFullElement.classList.contains('open');
          if (!isOpen && searchresponsive) {
            setSearchresponsive(false);
          }
        }
      });
    });

    if (searchFullElement) {
      observer.observe(searchFullElement, { attributes: true });
    }

    return () => {
      if (searchFullElement) {
        observer.disconnect();
      }
    };
  }, [searchresponsive]);

  const SearchResponsive = () => {
    const searchFullElement = document.querySelector('.search-full');
    const moreLangElement = document.querySelector('.more_lang');

    if (searchFullElement) {
      // Toggle search immediately without checking state first
      if (searchFullElement.classList.contains('open')) {
        searchFullElement.classList.remove('open');
        setSearchresponsive(false);
      } else {
        searchFullElement.classList.add('open');
        if (moreLangElement) {
          moreLangElement.classList.remove('active');
        }
        setSearchresponsive(true);
      }
    }
  };

  return (
    <li>
      <span className='header-search'>
        <SvgIcon iconId='search' onClick={SearchResponsive} />
      </span>
    </li>
  );
};

export default Searchbar;